import { InputField } from 'lib/iterable-hook-form/FormField';
import { CallWebhookNodeData } from 'modules/workflows/types';
import { useFormState } from 'react-hook-form';
import { ErrorText } from 'ui/formField';
import { StyledLeftTooltip } from '../../../EditorBody.styled';
import { AUTH_TOKEN_FIELD, ENDPOINT_FIELD } from '../CallWebhookEditor.constants';
import { Content, FormSectionContent, StyledHeader } from '../CallWebhookEditor.styled';
import { CallWebhookEditorFormSchemaType } from '../CallWebhookFormProvider';

export const ENDPOINT_INPUT_TEST_ID = 'input-endpoint-url-id';
export const AUTH_TOKEN_INPUT_TEST_ID = 'input-authorization-token-id';
export const ERROR_TEST_ID = 'endpoint-error-text';

export const EndpointInput = ({
  isReadOnly,
  nodeData,
}: {
  isReadOnly: boolean;
  nodeData: CallWebhookNodeData;
}) => {
  const { errors } = useFormState<CallWebhookEditorFormSchemaType>();
  const { nodeData: nodeDataErrors } = errors;

  return (
    <Content>
      <FormSectionContent>
        <StyledLeftTooltip isEnabled={isReadOnly} tooltipContent={nodeData[ENDPOINT_FIELD]}>
          <InputField
            id="input-endpoint-url"
            data-test={ENDPOINT_INPUT_TEST_ID}
            name={`nodeData.${ENDPOINT_FIELD}`}
            placeholder={'http://yourcompany.com/callback'}
            isDisabled={isReadOnly}
          />
          {nodeDataErrors?.endpoint && (
            <ErrorText data-test={ERROR_TEST_ID}>{nodeDataErrors.endpoint.message}</ErrorText>
          )}
        </StyledLeftTooltip>
      </FormSectionContent>

      <StyledHeader>
        Authorization token <span>(optional)</span>
      </StyledHeader>

      <InputField
        id="input-authorization-token"
        data-test={AUTH_TOKEN_INPUT_TEST_ID}
        name={`nodeData.${AUTH_TOKEN_FIELD}`}
        placeholder={'Value'}
        isDisabled={isReadOnly}
      />
    </Content>
  );
};
